import { render, staticRenderFns } from "./PressListPage.vue?vue&type=template&id=3d7f7614&scoped=true"
import script from "./PressListPage.vue?vue&type=script&lang=js"
export * from "./PressListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d7f7614",
  null
  
)

export default component.exports